// extracted by mini-css-extract-plugin
export default {"wrapper":"D4-z","play":"E4-z"};